import { Flex } from '@mantine/core';
import { SiestaAction } from '../types';
import { AIActionCard } from './AIActionCard';
import { AISetTitle } from './AISetTitle';

type Props = {
  actions: SiestaAction[];
  onActionClick?: (action: SiestaAction) => void;
};

export function AIActionSet({ actions, onActionClick }: Props) {
  return (
    <Flex direction="column" align="center">
      <AISetTitle />
      <Flex direction="column" gap="xxxs" mt="xxs" style={{ width: '100%' }}>
        {actions.map(action => (
          <AIActionCard
            key={action.id}
            label={action.label}
            onClick={() => onActionClick?.(action)}
          />
        ))}
      </Flex>
    </Flex>
  );
}
